import { ApolloError } from '@apollo/client';
import { Suspense } from 'react';
import { FormattedMessage } from 'react-intl';
import { useRouteError } from 'react-router-dom';

import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';
import { EmptyState } from '@sorare/core/src/components/EmptyState';
import { isNoInternetConnectionError } from '@sorare/core/src/lib/http';

import { Layout } from 'components/Layout';

export const ErrorBoundary = () => {
  const routeError = useRouteError();

  if (
    routeError instanceof ApolloError &&
    isNoInternetConnectionError(routeError)
  ) {
    return (
      <EmptyState
        title={
          <FormattedMessage
            id="blog.http-error"
            defaultMessage="Unable to load blog."
          />
        }
        ctaProps={{}}
      />
    );
  }

  throw routeError;
};

const BlogLayout = () => {
  return (
    <Suspense fallback={<LoadingIndicator fullHeight />}>
      <Layout />
    </Suspense>
  );
};
export default BlogLayout;
